import {
    ConsultaPage,
    ExcluirPage,
    EnvioPage,
    ImprimirPage,
    VisualizarPage,
    MenuPage,
    RecepcaoContratoPage,
    CadastrarCaixaPage,
    RecepcionarPage,
    UsuarioPreparacaoPage,
    ReimpressaoCapaPage,
    DashboardPage
} from '../views/Protocolo';

const protocoloIds = {
    IdAplicacao: 'E42EEFB0-FF92-4C59-BB0D-B8E41CFBDF5A',
    IdAplicacaoCliente: 'C0D0537E-E40D-44AB-A582-B0779FA92567'
}

const aplicacao = '/pos-loja';

const RouteProtocolo = [
    { path: `${aplicacao}/protocolo/dashboard`, exact: true, name: "Dashoard", component: DashboardPage },
    { path: `${aplicacao}/protocolo`, exact: true, name: 'Protocolo', component: MenuPage },
    {
        path: `${aplicacao}/protocolo/consulta-envio-protocolo`,
        exact: true,
        name: "Consulta Protocolo",
        component: MenuPage,
        ...protocoloIds
    },
    { 
        path: `${aplicacao}/protocolo/exclusao-protocolo`,
        exact: true,
        name: 'Exclusão de Protocolo',
        component: ExcluirPage,
        ...protocoloIds
    },
    { 
        path: `${aplicacao}/protocolo/consulta/visualizar/:idProtocolo`, 
        exact: true, 
        name: 'Detalhes do Protocolo',
        component: VisualizarPage ,
        ...protocoloIds
    },
    { 
        path: `${aplicacao}/protocolo/envio/:tipoProtocolo`, 
        exact: true, 
        name: 'Envio de Protocolo',
        component: EnvioPage ,
        ...protocoloIds
    },

    // { path: `${aplicacao}/protocolo/envio/:tipoProtocolo`, exact: true, name: 'Envio de Protocolo', component: EnvioPage  },


    { path: `${aplicacao}/protocolo/consulta/visualizar/imprimir`, exact: true, name: 'Imprimir Protocolo', component: ImprimirPage },
    { path: `${aplicacao}/protocolo/consulta/visualizar/:idProtocolo`, exact: true, name: 'Detalhes do Protocolo', component: VisualizarPage },
    // { path: `${aplicacao}/protocolo/envio/:tipoProtocolo`, exact: true, name: 'Envio de Protocolo', component: EnvioPage  },
    
    { path: `${aplicacao}/recepcao/recepcao-contrato/:mode`, exact: true, name: 'Recepção de Contrato', component: RecepcaoContratoPage }, 
    { path: `${aplicacao}/recepcao/cadastrarCaixa`, exact: true, name: 'Cadastro de Caixa', component: CadastrarCaixaPage },
    { path: `${aplicacao}/recepcao`, exact: true, name: 'Recepção', component: RecepcionarPage },
    { path: `${aplicacao}/recepcao/usuarios`, exact: true, name: 'Usuários de Preparação', component: UsuarioPreparacaoPage },
    { path: `${aplicacao}/recepcao/reimpressao`, exact: true, name: 'Reimpressão de Capa', component: ReimpressaoCapaPage},

    {
        path: `${aplicacao}/recepcao/usuarios`,
        exact: true, name: 'Usuários de Preparação',
        component: UsuarioPreparacaoPage,
        ...protocoloIds
    },
    { 
        path: `/protocolo/consulta/visualizar/:idProtocolo`,
        exact: true,
        name: 'Detalhes do Protocolo',
        component: VisualizarPage,
        ...protocoloIds
    },
    { path: `${aplicacao}/recepcao/reimpressao`, exact: true, name: 'Reimpressão de Capa', component: ReimpressaoCapaPage },
    
    

    { 
        path: `/pos-loja/protocolo/consulta/visualizar/imprimir`,
        exact: true,
        name: 'Imprimir Protocolo',
        component: ImprimirPage,
        ...protocoloIds
    },
    {
        path: `/pos-loja/protocolo/consulta`,
        exact: true,
        name: 'Pós Cadastro',
        component: ConsultaPage,
        ...protocoloIds
    },
    {
        path: `/pos-loja/preparacao`,
        exact: true,
        name: 'Pós-Lojas / Usuário de Preparação',
        component: UsuarioPreparacaoPage,
        ...protocoloIds
      },
];

export { RouteProtocolo };
